import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class Event extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/message/event'
    super(store, path)
  }
}
